export default __webpack_public_path__ + "static/media/property_division.3b7f20d3.svg";